import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StyxColorSelectComponent } from './select/color-select.component';

@NgModule({
    imports: [CommonModule],
    declarations: [StyxColorSelectComponent],
    entryComponents: [],
    exports: [StyxColorSelectComponent]
})
export class NgxStyxColorModule {}
